export { DisclaimerPage as default } from '@/components/pages/Ir/Disclaimer'
